<!--
  Иконка комментариев: сообщение.
  Обычно используется в блоках примечаний, комментариев и служебных заметок.
-->
<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="M21 12C21 16.4183 16.9706 20 12 20C10.7891 20 9.63405 19.7874 8.57969 19.4022L4 21L5.5455 17.2965C3.96848 15.9014 3 14.0385 3 12C3 7.58172 7.02944 4 12 4C16.9706 4 21 7.58172 21 12Z"
      :stroke="stroke"
      stroke-width="2"
      stroke-linejoin="round"
    />
    <path
      d="M8 11H16M8 14H13"
      :stroke="stroke"
      stroke-width="2"
      stroke-linecap="round"
    />
  </svg>
</template>

<script>
export default {
  name: "CommentIcon",

  props: {
    size: {
      type: [Number, String],
      default: 20,
    },
    stroke: {
      type: String,
      default: "currentColor",
    },
  },
};
</script>
